import { render } from "./FeaturedProductCategoriesComponent.vue?vue&type=template&id=4b0f5a62"
import script from "./FeaturedProductCategoriesComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedProductCategoriesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/FeaturedProductCategoriesComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b0f5a62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b0f5a62', __exports__)) {
    api.reload('4b0f5a62', __exports__)
  }
  
  module.hot.accept("./FeaturedProductCategoriesComponent.vue?vue&type=template&id=4b0f5a62", () => {
    api.rerender('4b0f5a62', render)
  })

}


export default __exports__